import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const OjetoNovy = lazy(() =>
  import('@/modules/ojeta-vozidla/OjetoNovy').then((m) => ({ default: m.OjetoNovy })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/ojeta-vozidla/novy',
  component: () => (
    <Suspense fallback={null}>
      <OjetoNovy />
    </Suspense>
  ),
});
